import { createPattern, escapeSelector } from '../utils';
import { ClassObjectType } from '../types';

// Pattern
export const pattern = createPattern('(border|content)-box', {breakpoints: true});

// Resolver
export const rules = (props): ClassObjectType => {
    const [className, breakpoint, value] = props;
    // console.log(className, breakpoint, value);
    const selector = escapeSelector(className);

    const rule = {
        [selector]: {
            boxSizing: `${value}-box`,
        }
    };

    return {
        breakpoint,
        rule
    };
}

export default { pattern, rules };